var map = {
	"./analyser-complete.svg": "1695",
	"./analyser-done.svg": "cde5",
	"./analyser.svg": "8bd4f",
	"./bing.svg": "c51b",
	"./google.svg": "b452",
	"./yahoo.svg": "fdeb",
	"./yandex.svg": "72ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9fac";